import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SChangePasswordForm = styled.form`
  margin-top: 32px;

  ${setFlexDFFDC};
`;
